import ChatDemo from "./components/chat-demo";
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";
// import mBgImage from "@/assets/images/bg-1-mobile.png";

const IntroPage = () => {
  const navigate = useNavigate();
  return (
    <div
      className="flex flex-col justify-center items-center bg-[#071807] overflow-x-hidden"
      style={{ fontFamily: "Lexend Deca, sans-serif" }}
    >
      <div className="flex flex-col mt-[100px] md:mt-[175px] mb-1 max-w-[1000px] px-5 md:px-0">
        <div className="text-[40px] leading-[40px] md:text-[80px] md:leading-[80px] font-[600] text-white text-center">
          <FormattedMessage id="LANDINGPAGE.MAIN.TITLE1" />
        </div>
        {/* bg-clip-text text-transparent */}
        <div
          className="text-[40px] md:text-[80px] leading-[40px] md:leading-[80px] h-[40px] md:h-[80px] font-bold bg-gradient-to-b from-white to-[#5AE65E] bg-clip-text text-transparent text-center"
          style={{ textShadow: "0px 3px 9.5px rgba(80, 181, 83, 0.4)" }}
        >
          <FormattedMessage id="LANDINGPAGE.MAIN.TITLE2" />
        </div>
      </div>

      <div className="text-[18px] mt-5 font-[300] text-white max-w-[720px] text-center hidden md:block">
        <FormattedMessage id="LANDINGPAGE.MAIN.DESC" />
      </div>
      <div className="bg-top-0 bg-no-repeat bg-contain w-full relative pt-[200px] md:!pt-1 md:pt-[100px] md:mt-[100px] bg-custom-1 md:bg-none">
        <div className="w-full flex justify-center">
          <button
            className="w-[142px] h-[40px] rounded-[11px] text-center bg-[#50B553] text-white cursor-pointer absolute z-1 top-[100px] md:!top-[-70px]"
            onClick={() => navigate("/auth/login")}
          >
            <FormattedMessage id="LANDINGPAGE.MAIN.START_NOW" />
          </button>
        </div>
        <div className="w-full flex justify-center">
          <img
            src="/media/images/landing-page/bg-1.png"
            alt="bg-1"
            className="h-full w-full absolute top-[-60px] l-0 hidden md:block"
          />
          <ChatDemo />
        </div>
      </div>
      {/* <div className="justify-evenly mt-10 hidden md:flex px-5">
        <div className="w-[13%] flex justify-center items-center">
          <img src="/media/images/landing-page/logo-vnpt.png" alt="logo-vnpt" />
        </div>
        <div className="w-[13%] flex justify-center items-center">
          <img src="/media/images/landing-page/logo-viettel.png" alt="logo-viettel" />
        </div>
        <div className="w-[13%] flex justify-center items-center">
          <img src="/media/images/landing-page/logo-vtc.png" alt="logo-vtc" />
        </div>
        <div className="w-[13%] flex justify-center items-center">
          <img src="/media/images/landing-page/logo-vtvcab.png" alt="logo-vtvcab" />
        </div>
        <div className="w-[13%] flex justify-center items-center">
          <img src="/media/images/landing-page/logo-mtu.png" alt="logo-mtu" />
        </div>
        <div className="w-[13%] flex justify-center items-center">
          <img src="/media/images/landing-page/logo-vov.png" alt="logo-vov" />
        </div>
        <div className="w-[13%] flex justify-center items-center">
          <img src="/media/images/landing-page/logo-mobifone.png" alt="logo-mobifone" />
        </div>
      </div> */}
    </div>
  );
};

export default IntroPage;
